import { createSlice } from '@reduxjs/toolkit';
import { MembershipState } from './state';
import reducers from './reducers';

const initialState: MembershipState = {
  membership: null,
  member: null,
  members: [],
  membershipSpace: [],
  exceptMembers: [],
  numperMember: 0,
  invite_code: null,
};

const membership = createSlice({
  name: 'membership',
  initialState,
  reducers,
});

export const membershipActions = { ...membership.actions };
export default membership;
